export const NEW_MESSAGE = 'new_message';
export const THINK_CHAT_UPDATED = 'think_chat_updated';
export const NEW_THINK_CHAT_INVITATION = 'new_invitation_think_chat';
export const NEW_THINK_TANK_REQUEST = 'new_think_tank_request';
export const NEW_THINK_TANK = 'new_think_tank';
export const NEW_SPEED_DATING_MEETING = 'new_speed_dating_meeting';
export const NEW_USER_CONNECTION = 'new_user_connection';
export const HAS_PENDING_REQUESTS = 'has_pending_requests';
export const NEW_USER_IN_IMPACT_EVENT = 'new_user_in_impact_event';
export const NEW_TABLE_JOINED = 'new_table_joined';
export const NOTIFICATION_MODAL = 'notification_modal';



// WEBPACK FOOTER //
// ./src/constants/notifications.js